module.exports = __webpack_public_path__ + "files/037a57a65ffe9d134093dc3f24cb6854.png";